import { useQuery } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { adaptAccountType } from 'api/escrow/adapters';
import { AccountType } from 'api/escrow/types';
import { memoryQueryClient } from 'providers/TanstackQuery';

async function getPayoutAccountTypes(): Promise<AccountType[]> {
  const result = await axiosClient.query.get('/api/v1/escrow/payout-account-types');
  return (result.data.account_types ?? []).map(adaptAccountType);
}

export const getPayoutAccountTypesQueryKey = () => ['escrow', 'payout-account-types'] as const;

export function useGetPayoutAccountTypesQuery(enabled = true) {
  return useQuery(
    {
      queryKey: getPayoutAccountTypesQueryKey(),
      queryFn: getPayoutAccountTypes,
      enabled,
    },
    memoryQueryClient,
  );
}
